<script lang="ts">
  import { uniq } from "lodash-es";
  import { searchFilter, updateSearchFilter } from "state/page";
  import {
    digitalSourceTypeGroupLabels,
    type DigitalSourceTypeGroupLabels,
  } from "bildebanken-model";
  $: selected = $searchFilter?.digitalSourceTypeGroups ?? [];

  function onChange(this: HTMLInputElement & { value: DigitalSourceTypeGroupLabels }) {
    if (this.checked) {
      updateSearchFilter("digitalSourceTypeGroups", uniq(selected.concat(this.value)));
    } else {
      updateSearchFilter(
        "digitalSourceTypeGroups",
        selected.filter((v) => v !== this.value),
      );
    }
  }
</script>

<button type="button">Innholdstype</button>
<bb-expand hidden={!selected.length}>
  <div class="sources">
    {#each digitalSourceTypeGroupLabels as digitalSourceTypeGroup (digitalSourceTypeGroup)}
      <label>
        <input
          type="checkbox"
          class="org-input"
          checked={selected.includes(digitalSourceTypeGroup)}
          on:change={onChange}
          value={digitalSourceTypeGroup}
        />
        {digitalSourceTypeGroup}
      </label>
    {/each}
  </div>
</bb-expand>

<style>
  /** Alignment is off with default values, but shouldn't need this much tweaking */
  .sources {
    display: flex;
    flex-direction: column;
    gap: var(--org-xsmall);
  }
</style>
